import { Download } from "react-feather";
import { Href } from "../../../../Constants/Constants";
import { DocumentsData } from "../../../../Data/Messenger/Messenger";

const Document = () => {
  return (
    <ul className="chat-main gallery-document">
      {DocumentsData.map((doc, index) => (
        <li key={index}>
          <div className="chat-box">
            <div className="d-flex">
              <div className="profile">
                <a className={`icon-btn ${doc.bgColorClass} btn-xl pull-right`} href={Href}>
                  <i className={`fa ${doc.iconClass}`} />
                </a>
              </div>
              <div className="details">
                <h4>{doc.title}</h4>
                <h6>{doc.date}</h6>
              </div>
              <div className="flex-grow-1">
                <a className="icon-btn btn-outline-light btn-sm pull-right" href={Href}><Download /></a>
              </div>
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
};

export default Document;
